module.exports = __webpack_public_path__ + "img/moveJob-hold.c71f0cfb.svg";